import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store';

import Experiments from '@/components/ExperimentsOverview.vue';
import CreateExperiment from '@/components/CreateExperiment.vue';
import ExperimentDetailPage from '@/views/ExperimentDetailPage.vue';
import CreateProject from '@/components/CreateProject.vue';
import ProjectDetailPage from '@/views/ProjectDetailPage.vue';
import Projects from '@/components/ProjectList.vue';
import CreateLocation from '@/components/CreateLocation.vue';
import LocationDetailPage from '@/views/LocationDetailPage.vue';
import Instruments from '@/components/InstrumentList.vue'
import InstrumentDetailPage from '@/views/InstrumentDetailPage.vue';
import CreateInstrument from '@/components/CreateInstrument.vue';
import Workflows from '@/components/WorkflowList.vue'
import WorkflowDetailPage from '@/views/WorkflowDetailPage.vue';
import CreateWorkflow from '@/components/CreateWorkflow.vue';
import ActionDetailPage from '@/views/ActionDetailPage.vue'
import MdListDetailPage from '@/views/MdListDetailPage.vue'
import MdLists from '@/components/MdListList.vue'
import CreateSeries from '@/components/CreateSeries.vue'
import ExportExperiments from '@/components/ExportExperiments.vue'
import LocationList from '@/components/LocationList.vue'
import WelcomePage from '@/views/WelcomePage.vue';
import MaterialList from "@/components/MaterialList.vue";
import CreateMaterial from '@/components/CreateMaterial.vue';
import MaterialDetailPage from '@/views/MaterialDetailPage.vue';
import RecordList from '@/components/RecordList.vue';
import CreateRecord from '@/components/CreateRecord.vue';
import RecordDetailPage from '@/views/RecordDetailPage.vue';
import ProjectStructurePage from '@/views/ProjectStructurePage.vue';
import ProjectStructureSetBuilderPage from '@/views/ProjectStructureSetBuilderPage.vue';
import StructureElementDetailPage from '@/views/StructureElementDetailPage.vue';

const routes = [
  {
    path: '/',
    name: 'WelcomePage',
    component: WelcomePage,
    meta: { public: true }
  },
  {
    path: '/experiments',
    name: 'Experiments',
    component: Experiments
  },
  {
    path: '/create-experiment',
    name: 'CreateExperiment',
    component: CreateExperiment
  },
  {
    path: '/experiments/:id',
    name: 'ExperimentDetailPage',
    component: ExperimentDetailPage,
    props: true 
  },
  {
    path: '/create-project',
    name: 'CreateProject',
    component: CreateProject
  },
  {
    path: '/projects/:id',
    name: 'ProjectDetailPage',
    component: ProjectDetailPage,
    props: true
  },
  {
    path: '/projects',
    name: "Projects",
    component: Projects
  },
  {
    path: "/create-location",
    name: "CreateLocation",
    component: CreateLocation,
    props: true
  },
  {
    path: "/locations/:id",
    name: "LocationDetailPage",
    component: LocationDetailPage
  },
  {
    path: "/instruments",
    name: "Instruments",
    component: Instruments
  },
  {
    path: "/instruments/:id",
    name: "InstrumentDetailPage",
    component: InstrumentDetailPage,
    props: true  
  },
  {
    path: "/workflows",
    name: "Workflows",
    component: Workflows
  },
  {
    path: "/workflows/:id",
    name: "WorkflowDetailPage",
    component: WorkflowDetailPage,
    props: true
  },
  {
    path: "/actions/:id",
    name: "ActionDetailPage",
    component: ActionDetailPage,
    props: true
  },
  {
    path: "/create-instrument",
    name: "CreateInstrument",
    component: CreateInstrument
  },
  {
    path: "/create-workflow",
    name: "CreateWorkflow",
    component: CreateWorkflow
  },
  {
    path: "/mdlists/:id",
    name: "MdListDetailPage",
    component: MdListDetailPage,
    props: true
  },
  {
    path: "/mdlists",
    name: "MdLists",
    component: MdLists
  },
  {
    path: "/create-series",
    name: "CreateSeries",
    component: CreateSeries
  },
  {
    path: "/export/",
    name: "ExportExperiment",
    component: ExportExperiments
  },
  {
    path: "/locations",
    name: "LocationList",
    component: LocationList
  },
    {
        path: "/materials",
        name: "MaterialList",
        component: MaterialList
    },
    {
        path: "/create-material",
        name: "CreateMaterial",
        component: CreateMaterial
    },
    {
        path: "/materials/:id",
        name: "MaterialDetailPage",
        component: MaterialDetailPage
    },
    {
      path: "/records",
      name: "RecordList",
      component: RecordList
    },
    {
      path: "/create-record",
      name: "CreateRecord",
      component: CreateRecord
    },
    {
      path: "/record/:id",
      name: "RecordDetailPage",
      component: RecordDetailPage
    },
    {
      path: "/project-structure",
      name: "ProjectStructurePage",
      component: ProjectStructurePage
    },
    {
      path: "/project-structure/sets/:setId",
      name: "ProjectStructureSetBuilderPage",
      component: ProjectStructureSetBuilderPage,
      props: true
    },
    {
      path: "/projects/:projectId/structure/elements/:elementId",
      name: "StructureElementDetailPage",
      component: StructureElementDetailPage,
      props: true
    }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const isPublic = to.meta.public;
  const isLoggedIn = !!store.state.loggedInUser;

  if (!isPublic && !isLoggedIn) {
    // Redirect to WelcomePage if not logged in
    next({ name: 'WelcomePage' });
  } else {
    next();
  }
});

export default router
